module.exports = __webpack_public_path__ + "assets/img/icon10.de353f42.png";